module.exports = __webpack_public_path__ + "img/new-nyc-logo.7f834b17.png";